import { createContext } from 'react';
import { dictionaryList} from '.';
// create the language context with default selected language
export const LanguageContext = createContext({
  userLanguage: 'de',
  dictionary: dictionaryList.en
});